import { axiosInstanceWebsite, axiosInstanceAnalytics } from "./instance";
import { AnalyticsFunnelPayload, FunnelPayload } from "./interface";

export const postFunnel = async (payload: FunnelPayload) => {
    const response = await axiosInstanceWebsite.post('/websites', payload);
    return response.data;
};

export const duplicateFunnel = async (websiteId: string) => {
    const response = await axiosInstanceWebsite.post(`/websites/${websiteId}/clone`);
    return response.data;
};

export const getAnalyticsFunnel = async (data: AnalyticsFunnelPayload) => {
    const response = await axiosInstanceAnalytics.post(`/dashboard-analytics`, data);
    return response.data;
};

export const getSectionFunnel = async (websiteId: string, sectionId: string) => {
    const response = await axiosInstanceWebsite.get(`/websites/${websiteId}/sections/${sectionId}`);
    return response.data;
};

export const getSectionsGenerated = async (data: string[]) => {
    const response = await axiosInstanceWebsite.post(`/websites/sections/generated`, data);
    return response.data;
};